import { render, staticRenderFns } from "./LeftPlan.vue?vue&type=template&id=235dcb22&scoped=true"
import script from "./LeftPlan.vue?vue&type=script&lang=js"
export * from "./LeftPlan.vue?vue&type=script&lang=js"
import style0 from "./LeftPlan.vue?vue&type=style&index=0&id=235dcb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235dcb22",
  null
  
)

export default component.exports